import {Logo} from "@cocunat/ui-components"

function HeaderQuizz() {
    return (
        <header style={{textAlign: "center", padding: 20}}>
            <Logo />
        </header>
    );
}

export default HeaderQuizz;
